module.exports = __webpack_public_path__ + "static/media/addPhoto.76cfc169.svg";